import React, { useEffect, useState } from "react";
import { registerLocale } from "react-datepicker";
import { tr } from "date-fns/locale/tr";
import { ApiService } from "../services/http.service";
import { formatDate } from "date-fns";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import WayType from "../components/shared/way_type/way_type";
import { isMobile } from "../App";

import { getPrettyFormatLastSix } from "../services/misc.functions";
import camera from "../assets/icons/camera.png";
import play from "../assets/icons/play-button.png";
import { shownRun, statisticsOptions } from "../stores/statistics.store";
import _ from "lodash";
import { modalServiceSubject } from "../components/shared/modal/Modal";

registerLocale("tr", tr);

export const WhoRunWithWhom: React.FC<any> = () => {
  const [results, setResults] = useState<any>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [withRuns, setWithRuns] = useState<any>(null);
  const [raceDetail, setRaceDetail] = useState<any>(null);
  const [visibleRuns, setVisibleRuns] = useState<{ [key: string]: boolean }>({});
  const api = new ApiService();

  useEffect(() => {
    setLoading(true);
    api
      .start("get", "https://tjk-statistics.bitrelic.io/api/who-ran-with-whom/", null)
      .then((res: any) => {
        if (res.data) {
          setResults(res.data);
        }
        setLoading(false);
      })
      .catch((e) => console.log(e));
  }, [statisticsOptions.date]);

  useEffect(() => {
    if (results && shownRun) {
      setWithRuns(
        results.find((item: any) => item.hippodrome_key === shownRun.hippodrome_key && item.run_no === shownRun.run_no)
          ?.runners_data
      );
    }
  }, [results, shownRun]);

  const groupByRace = (runs: any) => {
    const grouped: any = {};
    runs.forEach((run: any) => {
      run.ran_with_whom.forEach((withWhom: any) => {
        const key = `${withWhom.date}-${withWhom.hippodrome}`;
        if (!grouped[key]) {
          grouped[key] = {
            date: withWhom.date,
            hippodrome: withWhom.hippodrome,
            way_type: withWhom.running_track_name,
            distance: withWhom.distance,
            horses: [],
          };
        }
        grouped[key].horses.push(withWhom);
      });
    });
    return Object.values(grouped);
  };

  const groupedRuns = withRuns ? groupByRace(withRuns) : [];

  const toggleRunnersVisibility = (runKey: string, run: any) => {
    const [year, month, day] = run.date.split("-");
    const api = new ApiService();

    api.start("get", `https://bulletin.4nala.com/api/results/${day}${month}${year}/`, null).then((res: any) => {
      if (res?.data) {
        const resultOfRace = res.data.find((item: any) => item.location === run.horses[0].location)?.runs[
          run.horses[0].run_no - 1
        ];

        if (resultOfRace) {
          setRaceDetail((prev: any) => ({
            ...prev,
            [runKey]: resultOfRace,
          }));
        } else {
          setRaceDetail((prev: any) => ({
            ...prev,
            [runKey]: "no data",
          }));
        }
      }
    });

    setVisibleRuns((prev) => ({
      ...prev,
      [runKey]: !prev[runKey],
    }));
  };

  return (
    <div>
      {loading ? (
        <div className="d-flex justify-content-center align-items-center">
          <div id="id_loaderAnimation" className="loader"></div>
        </div>
      ) : withRuns && groupedRuns.length > 0 ? (
        !isMobile ? (
          <div className="table-responsive">
            <table className="table statistics-table table-borderless">
              <thead>
                <tr style={{ cursor: "pointer", backgroundColor: "#EDEEFB" }}>
                  <th colSpan={3}></th>
                  <th className="text-center">Tarih</th>
                  <th colSpan={3}></th>
                  <th className="text-center">Hipodrom</th>
                  <th colSpan={3}></th>
                  <th className="text-center">Pist</th>
                  <th colSpan={3}></th>
                  <th className="text-center">Mesafe</th>
                  <th colSpan={3}></th>
                  <th className="text-center">Birlikte Koşan Atlar</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {_.orderBy(groupedRuns, ["date"], ["desc"]).map((run: any, index: number) => {
                  const runKey = `${run.date}-${run.hippodrome}`;
                  const isVisible = visibleRuns[runKey] || false;

                  return (
                    <React.Fragment key={`DataTable-runs-${index}`}>
                      <tr
                        className={`who-whom ${isVisible ? "active" : ""}`}
                        style={{ cursor: "pointer", backgroundColor: "#646BDD15" }}
                        onClick={() => toggleRunnersVisibility(runKey, run)}
                      >
                        <td colSpan={3}></td>
                        <td>{formatDate(new Date(run.date), "dd.MM.yyyy")}</td>
                        <td colSpan={3}></td>
                        <td>{run.hippodrome}</td>
                        <td colSpan={3}></td>
                        <td>
                          <WayType type={run.way_type} />
                        </td>
                        <td colSpan={3}></td>
                        <td>{run.distance}</td>
                        <td colSpan={3}></td>
                        <td className="text-center flex-wrap">
                          {run.horses
                            .filter(
                              (runner: any, index: number, self: any[]) =>
                                index === self.findIndex((r: any) => r.result === runner.result)
                            )
                            .sort((a: any, b: any) => a.result - b.result)
                            .map((horse: any, index: number, array: any[]) => {
                              return `${horse.result}. ${horse.name}${index < array.length - 1 ? " | " : ""}`;
                            })}
                        </td>
                        <td>{isVisible ? <IoIosArrowUp /> : <IoIosArrowDown />}</td>
                      </tr>

                      {isVisible && (
                        <tr style={{ backgroundColor: "#E1E3F7" }}>
                          <td colSpan={21} style={{ padding: 0 }}>
                            <table className="table table-borderless m-0 p-0 pt-0 mt-0 fw-bold">
                              <tr>
                                <td className="text-start px-4">
                                  {formatDate(new Date(run.date), "dd.MM.yyyy")} / {run.distance} {run.way_type} /{" "}
                                  {run.horses[0].run_group} / {run.horses[0].run_breed_detail}{" "}
                                </td>

                                <td
                                  className="text-end px-5"
                                  onClick={(event) => {
                                    event.stopPropagation();
                                  }}
                                >
                                  {run.horses[0].photo_finish && decodeURI(run.horses[0].photo_finish).trim() ? (
                                    <img
                                      src={camera}
                                      alt="FF"
                                      width={15}
                                      height={15}
                                      className="mb-1"
                                      onClick={() => {
                                        modalServiceSubject.next({
                                          content: (
                                            <img
                                              alt="photo_finish"
                                              src={decodeURI(run.horses[0].photo_finish)}
                                              style={{
                                                maxWidth: "100%",
                                                height: "auto",
                                                width: "auto",
                                              }}
                                            />
                                          ),
                                          confirm: {
                                            cancel: {
                                              label: "Kapat",
                                            },
                                          },
                                        });
                                      }}
                                    />
                                  ) : (
                                    ""
                                  )}

                                  {/* {run.horses[0].video && decodeURI(run.horses[0].video).trim() ? (
                                    <img
                                      src={play}
                                      alt="play"
                                      width={15}
                                      height={15}
                                      className="mb-1"
                                      onClick={() => {
                                        modalServiceSubject.next({
                                          content: (
                                            <video controls autoPlay style={{ width: "100%" }}>
                                              <source src={decodeURI(run.horses[0].video)} type="video/mp4" />
                                            </video>
                                          ),

                                          confirm: {
                                            cancel: {
                                              label: "Kapat",
                                            },
                                          },
                                        });
                                      }}
                                    />
                                  ) : (
                                    ""
                                  )} */}
                                </td>
                              </tr>
                            </table>
                          </td>
                        </tr>
                      )}

                      {isVisible && (
                        <tr>
                          <td colSpan={21} style={{ padding: 0 }}>
                            <table className="table who-whom-table table-borderless m-0 p-0 pt-0 mt-0">
                              <thead>
                                <tr>
                                  <th>Sıra</th>
                                  <th className="text-start">At İsmi</th>
                                  <th>Kilo</th>
                                  <th>Jokey</th>
                                  <th className="text-start">Orijin</th>
                                  <th className="text-start">Sahip / Antrenör</th>
                                  <th>Son 6</th>
                                  <th>Derece</th>
                                  <th>Start</th>
                                  <th>Fark</th>
                                  <th className="text-nowrap">G. Çıkış</th>
                                  <th>HP</th>
                                  <th>AGF</th>
                                  <th>GNY</th>
                                </tr>
                              </thead>
                              <tbody>
                                {raceDetail && raceDetail[runKey] ? (
                                  raceDetail[runKey].horses && raceDetail[runKey].horses.length > 0 ? (
                                    raceDetail[runKey].horses.map((runner: any, trainingKey: number) => {
                                      const isMatch = run.horses.find((horse: any) => horse.name === runner.name);

                                      return (
                                        <tr
                                          key={`Tjk-races-${trainingKey}`}
                                          className={isMatch ? "who-whom-matched" : ""}
                                        >
                                          <td>{runner.result}</td>
                                          <td className="text-start d-flex flex-column">
                                            <span>
                                              {" "}
                                              ({runner.no}) {runner.name}{" "}
                                            </span>

                                            <span>
                                              <span className="horse-age">{runner.age}</span>{" "}
                                              <span className="horse-jewelry">{runner.jewelry}</span>
                                            </span>
                                          </td>
                                          <td>
                                            <span>{runner.weight}</span>
                                            <br />
                                            <span className="text-danger">
                                              {runner.extra_weight
                                                ? `${runner.extra_weight > 0 ? "+" : "-"}${runner.extra_weight}`
                                                : ""}
                                            </span>
                                          </td>
                                          <td>{runner.jokey}</td>
                                          <td className="text-start">
                                            {runner.father}-{runner.mother}
                                          </td>
                                          <td className="text-start">{runner.owner}</td>
                                          <td className="fw-bold">
                                            <span
                                              dangerouslySetInnerHTML={{ __html: getPrettyFormatLastSix(runner.last6) }}
                                            ></span>
                                          </td>
                                          <td>{runner.degree}</td>
                                          <td>{runner.start}</td>
                                          <td className="text-start">{runner.difference}</td>
                                          <td>{runner.late_start}</td>
                                          <td>{runner.handicap || 0}</td>
                                          <td>%{runner.AGF1 || "-"}</td>
                                          <td>{runner.ganyan}</td>
                                        </tr>
                                      );
                                    })
                                  ) : (
                                    <tr>
                                      <td colSpan={10} className="text-center">
                                        Gösterilecek Veri Bulunamadı.
                                      </td>
                                    </tr>
                                  )
                                ) : (
                                  <tr>
                                    <td colSpan={10} className="text-center">
                                      <div id="id_loaderAnimation" className="loader"></div>
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          </td>
                        </tr>
                      )}
                    </React.Fragment>
                  );
                })}
              </tbody>
            </table>
          </div>
        ) : (
          <div className="mobile-who-whom-table">
            {_.orderBy(groupedRuns, ["date"], ["desc"]).map((run: any, index: number) => {
              const runKey = `${run.date}-${run.hippodrome}`;
              const isVisible = visibleRuns[runKey] || false;

              return (
                <div className="table-item" key={`who-run-with-whom-${index}`}>
                  <div
                    className="row"
                    onClick={() => toggleRunnersVisibility(runKey, run)}
                    style={{ cursor: "pointer", backgroundColor: isVisible ? "#D7D9F7" : "" }}
                  >
                    <div className="col-10">
                      <div className="fw-medium">
                        {formatDate(new Date(run.date), "dd.MM.yyyy")} / {run.hippodrome}
                      </div>
                      <div className="d-flex flex-row gap-1">
                        {run.distance}m /{" "}
                        <div
                          style={{
                            width: "40px",
                            height: "18px",
                            marginTop: "4px",
                          }}
                        >
                          <WayType type={run.way_type} />
                        </div>
                      </div>
                      <div className="fw-medium">
                        {run.horses
                          .filter(
                            (runner: any, index: number, self: any[]) =>
                              index === self.findIndex((r: any) => r.result === runner.result)
                          )
                          .sort((a: any, b: any) => a.result - b.result)
                          .map((horse: any, index: number, array: any[]) => {
                            return `${horse.name}${index < array.length - 1 ? " - " : ""}`;
                          })}
                      </div>
                    </div>
                    <div className="col-2 d-flex align-items-center justify-content-end">
                      {isVisible ? <IoIosArrowUp /> : <IoIosArrowDown />}
                    </div>
                  </div>

                  {isVisible && (
                    <div
                      className="d-flex flex-row justify-content-between align-items-center"
                      style={{ backgroundColor: "#E1E3F7", fontSize: 13, fontWeight: 600, paddingInline: "5px" }}
                    >
                      <div>
                        {run.date} / {run.distance} {run.way_type} / {run.horses[0].run_group} /{" "}
                        {run.horses[0].run_breed_detail}{" "}
                      </div>

                      <div
                        className="d-flex flex-row gap-2 align-items-center"
                        onClick={(event) => {
                          event.stopPropagation();
                        }}
                      >
                        {run.horses[0].photo_finish && decodeURI(run.horses[0].photo_finish).trim() ? (
                          <img
                            src={camera}
                            alt="FF"
                            width={15}
                            height={15}
                            className="mb-1"
                            onClick={() => {
                              modalServiceSubject.next({
                                content: (
                                  <img
                                    alt="photo_finish"
                                    src={decodeURI(run.horses[0].photo_finish)}
                                    style={{
                                      maxWidth: "100%",
                                      height: "auto",
                                      width: "auto",
                                    }}
                                  />
                                ),
                                confirm: {
                                  cancel: {
                                    label: "Kapat",
                                  },
                                },
                              });
                            }}
                          />
                        ) : (
                          <span>-</span>
                        )}

                        {/* {run.horses[0].video && decodeURI(run.horses[0].video).trim() ? (
                          <img
                            src={play}
                            alt="play"
                            width={15}
                            height={15}
                            className="mb-1"
                            onClick={() => {
                              modalServiceSubject.next({
                                content: (
                                  <video controls autoPlay style={{ width: "100%" }}>
                                    <source src={decodeURI(run.horses[0].video)} type="video/mp4" />
                                  </video>
                                ),

                                confirm: {
                                  cancel: {
                                    label: "Kapat",
                                  },
                                },
                              });
                            }}
                          />
                        ) : (
                          <span>-</span>
                        )} */}
                      </div>
                    </div>
                  )}

                  {isVisible ? (
                    raceDetail && raceDetail[runKey] ? (
                      raceDetail[runKey].horses && raceDetail[runKey].horses.length > 0 ? (
                        raceDetail[runKey].horses.map((runner: any, trainingKey: number) => {
                          return (
                            <div className={`runners row flex-nowrap show`} key={`who-whom-runner-${trainingKey}`}>
                              <div className="col-1 horse-no">{runner.result}</div>
                              <div className="col-4 horse-info">
                                <span className="horse-name">
                                  ({runner.no}) {runner.name}
                                </span>

                                <div className="row">
                                  <span className="col-4 horse-age">{runner.age}</span>{" "}
                                  <span className="col-8 horse-jewelry">{runner.jewelry}</span>
                                </div>

                                <div className="row">
                                  <span className="col-4">ST: {runner.start}</span>
                                  <span className="col-8">HP: {runner.handicap || "-"}</span>
                                </div>
                              </div>
                              <div className="col-4 runner-info">
                                <span className="runner-name">{runner.jokey}</span>
                                <span>
                                  {runner.weight} KG{" "}
                                  <span className="text-danger">
                                    {runner.extra_weight
                                      ? `${runner.extra_weight > 0 ? "+" : "-"}${runner.extra_weight}`
                                      : ""}
                                  </span>
                                </span>
                                <span
                                  className={`${runner.difference && "text-success"} ${
                                    runner.late_start && "text-danger"
                                  }`}
                                >
                                  {runner.difference || runner.late_start}
                                </span>
                              </div>
                              <div className="col-3 runner-result">
                                <span style={{ lineHeight: "24px", whiteSpace: "nowrap" }}>GNY: {runner.ganyan}</span>
                                <span>
                                  {runner.AGF_rank1}. %{runner.AGF1}
                                </span>
                                <span className="degree">DRC: {runner.degree}</span>
                              </div>
                            </div>
                          );
                        })
                      ) : (
                        <div className="text-center">Gösterilecek Veri Bulunamadı.</div>
                      )
                    ) : (
                      <div className="text-center">
                        <div id="id_loaderAnimation" className="loader"></div>
                      </div>
                    )
                  ) : (
                    <></>
                  )}
                </div>
              );
            })}
          </div>
        )
      ) : (
        <div className="text-center p-5">Gösterilecek istatistik verisi bulunmuyor.</div>
      )}

      <div className="info">
        <span className="title">Kim Kiminle Koştu</span>
        <span className="description">
          Bu koşuda start alacak olan atların, birlikte hangi yarışta, mesafede ve zeminde koştukları ile aldıkları
          derece verilerini içerir.
        </span>
      </div>
    </div>
  );
};
